module.exports = __webpack_public_path__ + "static/media/coins-tab-active.5fec0733.png";